import React from 'react';

import { useTrackingRefuel } from 'pages/TrackingRefuel/hooks/useTrackingRefuel';
import { getComplementRefuel } from 'utils/getComplementRefuel';
import { getRangeDateRefuel } from 'utils/getRangeDateRefuel';
import { getStatusType } from 'newComponents/NewNotifications/NotificationItem/util';
import timeLinePendent from '../../../../../assets/icons/timeLinePendent.svg';
import timeLineSuccess from '../../../../../assets/icons/timeLineSuccess.svg';
import timeLineError from '../../../../../assets/icons/timeLineError.svg';

import {
  TimelineContainer,
  TimelineItem,
  Circle,
  TextContainer,
  Label,
  Date,
  Img,
  StatusErrorMessage,
} from './styles';

const TimeLIne: React.FC = () => {
  const { orderStatus, dataDetail } = useTrackingRefuel();

  const { noSupplyCode, noVisitCode } = dataDetail;

  const statusResponse = getStatusType(
    dataDetail?.status?.code,
    'refuel',
    true
  );

  const previsaoDeEntregaResponse = getRangeDateRefuel(
    dataDetail.forecastDate,
    dataDetail?.beginDate ?? null,
    dataDetail?.endDate ?? null,
    dataDetail?.suggestedDate ?? null,
    dataDetail?.agreedDate ?? null,
    dataDetail?.reprogrammingDate ?? null,
    dataDetail?.deliveryDate ?? null,
    // @ts-ignore
    statusResponse ?? null
  );

  type GetStatusIconResponse = {
    image: string;
    isError: boolean;
    statusColor: string;
    complementRefuel?: string | null;
    previsaoDeEntrega?: string | null;
  };

  function getStatusIcon(
    status: string,
    isLast: boolean
  ): GetStatusIconResponse {
    if (status === 'PREVISAO_ENTREGA') {
      return {
        image: timeLineSuccess,
        isError: false,
        statusColor: 'concluído',
        previsaoDeEntrega: previsaoDeEntregaResponse,
      };
    }
    if (status === 'ATENDIDO' && isLast) {
      return {
        image: timeLineSuccess,
        isError: false,
        statusColor: 'atendido',
      };
    }
    if (
      status !== 'SNOREC' &&
      status !== 'CANREA' &&
      status !== 'ERRO' &&
      status !== 'CANCELADO' &&
      status !== 'NAO_ATENDIDO' &&
      status !== 'ATENDIDO' &&
      isLast
    ) {
      return { image: timeLinePendent, isError: false, statusColor: '' };
    }
    if (
      status !== 'SNOREC' &&
      status !== 'CANREA' &&
      status !== 'ERRO' &&
      status !== 'CANCELADO' &&
      status !== 'NAO_ATENDIDO' &&
      status !== 'ATENDIDO' &&
      !isLast
    ) {
      return {
        image: timeLineSuccess,
        isError: false,
        statusColor: 'concluído',
      };
    }
    if (
      (status === 'SNOREC' ||
        status === 'CANREA' ||
        status === 'ERRO' ||
        status === 'CANCELADO' ||
        status === 'NAO_ATENDIDO') &&
      isLast
    ) {
      return {
        image: timeLineError,
        isError: true,
        statusColor: 'error',
        complementRefuel: getComplementRefuel(
          status,
          noVisitCode,
          noSupplyCode,
          null,
          null,
          null,
          null,
          null
        ),
      };
    }

    return {
      image: '',
      isError: false,
      statusColor: '',
    };
  }

  return (
    <TimelineContainer>
      {orderStatus.map((item, index) => {
        const {
          image,
          isError,
          statusColor,
          complementRefuel,
          previsaoDeEntrega,
        } = getStatusIcon(item.status, index === orderStatus.length - 1);

        return (
          <TimelineItem
            key={String(`${item.eventDate}${index}`)}
            isLast={index === orderStatus.length - 1}
          >
            <Circle status={statusColor}>
              <Img src={image} />
            </Circle>
            <TextContainer>
              {previsaoDeEntrega && (
                <Label isError={isError}>
                  {`${item?.statusFormatted}${' '}
                  ${previsaoDeEntrega}`}
                </Label>
              )}
              {!previsaoDeEntrega && (
                <Label isError={isError}>{item?.statusFormatted}</Label>
              )}
              {complementRefuel && (
                <StatusErrorMessage>{complementRefuel}</StatusErrorMessage>
              )}
            </TextContainer>
          </TimelineItem>
        );
      })}
    </TimelineContainer>
  );
};

export default TimeLIne;
